import { AnySendBirdMessage } from '.';

export function isFAQBotAnswer(message: AnySendBirdMessage) {
  if (!message.data) {
    return false;
  }

  try {
    const messageData = JSON.parse(message.data);
    return (
      messageData.type === 'SENDBIRD_DESK_BOT_MESSAGE_FAQ_ANSWERS' &&
      messageData.results &&
      messageData.results.length > 0
    );
  } catch (error) {
    return false;
  }
}
